import(/* webpackMode: "eager" */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/components/loading-screen/loading-screen.jsx");
;
import(/* webpackMode: "eager" */ "/Users/feker/Desktop/Feker-repo/ShahenWebsite/src/components/loading-screen/splash-screen.jsx");
